export default "__VITE_ASSET__BBSdynY5__"